export default {
  meta: {
    title: '定点打靶' // 随手记功能，客户要求暂定以踩点记录命名
  }
};
